import React from 'react';
import EsquineroIzquierdo from '../assets/img/esquinero.png';
import EsquineroDerecho from '../assets/img/esquinero2.png';

export default function EsquinerosArriba() {
  return (
    <>
        <div className="d-flex esquinerosArriba">
          <div>
            <img alt="esquinero" className="img-fluid" src={EsquineroIzquierdo} />
          </div>
          <div>
            <img alt="esquinero" className="img-fluid" src={EsquineroDerecho} />
          </div>
        </div>
    </>
  );
}
